/** Keep server filter keys and raw entities; only adapt the displayed nested fields. */
export function engagementTableResponse(payload) {
  return { ...payload, header: (payload.header || []).map((column) => {
    if (column.name === "advertisement") return { ...column, type: "objectfield", link: "title" };
    if (column.name === "user") return { ...column, type: "objectfield", link: "displayName" };
    return column;
  }), data: (payload.data || []).map((row) => ({ ...row, user: row.user ? {
    ...row.user, displayName: [row.user.fname ?? row.user.Fname, row.user.lname ?? row.user.Lname]
      .filter(Boolean).join(" ") || row.user.name || String(row.user.id ?? row.user.Id ?? row.userId ?? ""),
  } : null })) };
}
